import { isDefined } from "@clipboard-health/util-ts";
import { useFacilityProfile } from "@src/appV2/Facilities/api/useFacilityProfile";

const DEFAULT_MANDATORY_BREAK_DURATION_IN_MINUTES = 30;

/**
 * @deprecated Read `breakPolicy` from the shift object instead. This hook will be
 * removed in TEM-2640 (https://linear.app/clipboardhealth/issue/TEM-2640).
 */
export function useGetFacilityBreakConfiguration(props: { workplaceId: string | undefined }) {
  const { workplaceId } = props;

  const enabled = isDefined(workplaceId) && workplaceId.length > 0;

  const {
    data: facilityProfile,
    isLoading,
    isSuccess,
  } = useFacilityProfile<"mandatoryBreakConfiguration">(
    {
      workplaceId: workplaceId ?? "",
      projection: "mandatoryBreakConfiguration",
    },
    {
      enabled,
      staleTime: 30 * 1000, // 30 seconds to avoid very frequent re-fetches
    }
  );

  const { mandatoryBreakConfiguration } = facilityProfile ?? {};

  return {
    mandatoryBreakDurationInMinutes:
      mandatoryBreakConfiguration?.breakDurationInMinutes ??
      DEFAULT_MANDATORY_BREAK_DURATION_IN_MINUTES,
    isLoading,
    isSuccess,
  };
}
